import { getLocalStorage } from '@/services/localSessionService';
import { memo } from 'react';

const Footer = () => {
  if(!getLocalStorage("config-json")){
    return <div className="px-6 grid grid-cols-1 md:grid-cols-3 mx-auto w-full text-white py-4 bg-primary text-sm">
    <div className='text-center md:text-left'>All Copyright &copy; reserved</div>
    <div className='text-center'><span>App Version : </span><span className='font-semibold'>Version</span></div>
    <div className='text-center md:text-right'>
      <span>Developed by</span>
      <a className="ml-1 text-white font-semibold" href="https://softwebtechno.com" target="_blank">
        Softweb Technologies
      </a>
    </div>
  </div>
  }

  const { version, copyright, company, companyUrl } = JSON.parse(getLocalStorage("config-json")!);

  return (
    <div className="px-6 grid grid-cols-1 md:grid-cols-3 mx-auto w-full text-white py-4 bg-primary text-sm">
      <div className='text-center md:text-left'>All Copyright &copy; reserved {copyright}</div>
      <div className='text-center'><span>App Version : </span><span className='font-semibold'>{version}</span></div>
      <div className='text-center md:text-right'>
        <span>Developed by</span>
        <a className="ml-1 text-white font-semibold" href={companyUrl} target="_blank">
          {company}
        </a>
      </div>
    </div>
  );
};

export default memo(Footer);
